export const Russian = {
  language: 'ru',
  data: {
    TRANSLATOR: {
      SELECT: 'Выберите язык',
      ENGLISH: 'Английский',
      RUSSIAN: 'Русский',
    },
    MENU: {
      HOME: 'Домой',
      PROFILE: 'Профиль',
      ACCOUNT: 'Аккаунт',
      SETTINGS: 'Настройки',
      IDENTITY: 'Идентичность',
      NOTIFICATION: 'Уведомление',
      CONFIGURATION: 'Конфигурация',
      INFO: 'Информация',
    },
    MODAL: {
      SAVE: 'Сохранить',
      CANCEL: 'Отменить',
      YES: 'Да',
      NO: 'Нет',
      DELETE_MESSAGE: 'Вы уверены, что хотите удалить',
      ADD_NEW_USER: 'Добавить пользователя',
      ADD_NEW_ROLE: 'Добавить новую роль',
      EDIT_USER: 'Редактирование пользователя',
      EDIT_ROLE: 'Редактирование роли',
      VIEW_USER: 'Просмотр данных пользователя',
      DELETE_USER: 'Удаление пользователя',
      DELETE_ROLE: 'Удаление роли',
      UPDATE_USER_PASSWORD: 'Обновить пароль пользователя',
    },
    NOTIFICATIONS: {
      TITLE: 'Уведомления',
      ALERTS: 'Оповещения',
      UPDATES: 'Обновления',
      LOGS: 'Журналы',
      VIEW_ALL: 'Смотреть все',
      UPGRADE: 'Модернизация',
      GET_PRO_ACCESS: 'Получить профессиональный доступ',
      ALL_ROLES: 'Все Роли',
      ALL_USERS: 'Все Пользователи',
      ALL_GROUPS: 'Все Группы',
      ALL_STATUSES: 'Все Статусы',
      NEW_NOTIFICATION: 'Новое Оповещение',
      MARK_AS_READ: 'Отметить Как Прочитано',
      SUBJECT: 'Субъект',
      MESSAGE: 'Сообщение',
      TYPE: 'Тип',
      ROLE: 'Роль',
      USER: 'Пользователь',
      CREATION_TIME: 'Время Создания',
      STATUS: 'Статус',
      ACTION: 'Действие',
      GROUP: 'Группа',
      NEW_NOTIFICATIONS: {
        ROLE_ID: 'Роль Id',
        USER_NAME: 'Имя Пользователя',
        TITLE: 'Название',
        ALL: 'Все',
      },
    },
    GROUPS: {
      TITLE: 'Группы',
      NEW_GROUP: 'Новая Группа',
      NAME: 'Название',
      DESCRIPTION: 'Описание',
      ROLES: 'Роли',
      CREATION_TIME: 'Время Создания',
      ACTION: 'Действие',
    },
    IDENTITY: {
      TITLE: 'Идентичность',
      USERS: 'Пользователи',
      NEW_USER: 'Новый пользователь',
      NEW_ROLE: 'Новая роль',
      SEARCH: 'Поиск',
      USER_NAME: 'Имя пользователя',
      FIRST_NAME: 'Имя',
      EMAIL: 'Электронная почта',
      ROLE: 'Роль',
      ROLE_NAME: 'Название роли',
      ACTIONS: 'Действия',
      NAME: 'Имя',
      SHOW: 'Показать',
      TO: 'до',
      OF: 'из',
      ENTRIES: 'записей',
    },
    COMMON: {
      SEARCH: 'Поиск',
      PAGINATION: 'Показывать {{from}} до {{to}} записей {{all}}',
      NO_DATA_AVAILABLE_IN_TABLE: 'Данные в таблице отсутствуют',
      COPY_TO_CLIPBOARD: 'Копируется в буфер обмена: {{value}}',
      GO_TO: 'Перейти на страницу',
      ITEMS_PER_PAGE: 'Элементы на странице',
    },
    AUTH: {
      // ? ACTUAL
      TITLES: {
        LOGIN: 'Вход в систему',
        REGISTER: 'Регистрация',
        FORGOT: 'Забыли пароль?',
        RESET_PASSWORD: 'Сброс пароля',
      },
      // ? ACTUAL
      GENERAL: {
        OR: 'или',
        SUBMIT_BUTTON: '提交',
        NO_ACCOUNT: '没有账号？',
        SIGNUP_BUTTON: 'Зарегистрироваться',
        FORGOT_BUTTON: 'Забыли пароль?',
        BACK_BUTTON: '背部',
        PRIVACY: '隐私',
        LEGAL: '法律',
        CONTACT: '联系',
        PLEASE_WAIT: 'Пожалуйста подождите',
        CONTINUE: 'Продолжить',
      },
      LOGIN: {
        TITLE: 'Вход в систему в',
        BUTTON: '签到',
        NEW_HERE: 'Новый здесь',
        CONTINUE_WITH_GOOGLE: 'Продолжить работу с Google',
      },
      FORGOT: {
        TITLE: 'Forgotten Password?',
        DESC: 'Enter your email to reset your password',
        SUCCESS: 'Your account has been successfully reset.',
      },
      REGISTER: {
        TITLE: 'Зарегистрироваться',
        ALREADY_HAVE_ACCOUNT: 'Уже есть аккаунт',
        SIGN_IN: 'Войти',
        DESC: 'Enter your details to create your account',
        SUCCESS: 'Your account has been successfuly registered.',
        AGREE: 'Я согласен с тем, что',
        TERMS_AND_CONDITIONS: 'положения и условия',
        SUBMIT: 'Отправить',
        CANCEL: 'Отмена',
      },
      INPUT: {
        EMAIL: 'Электронная почта',
        FULLNAME: 'Полное имя',
        PASSWORD: 'Пароль',
        NEW_PASSWORD: 'Новый пароль',
        CONFIRM_PASSWORD: 'Подтверждение пароля',
        USERNAME: 'Имя пользователя',
      },
      VALIDATION: {
        INVALID: '{{name}} недействителен',
        REQUIRED: '{{name}} необходим',
        MIN_LENGTH: '{{name}} минимальная длина {{min}}',
        AGREEMENT_REQUIRED: 'Необходимо принять условия и положения',
        NOT_FOUND: 'Запрошенный {{name}} не найден',
        INVALID_LOGIN: 'Данные для входа в систему неверны',
        PATTERN: 'Поле не соответствует шаблону',
        MAX_LENGTH: 'Максимальная длина поля',
        REQUIRED_FIELD: 'Обязательное поле',
        MIN_LENGTH_FIELD: 'Минимальная длина поля:',
        MAX_LENGTH_FIELD: 'Максимальная длина поля:',
        INVALID_FIELD: 'Поле недействительно',
        MUST_MATCH: 'Пароли не совпадают!',
      },
    },
    DASHBOARD: {
      WELCOME_MESSAGE: 'Добро пожаловать домой',
      LANGUAGE: 'Язык',
      SIGN_OUT: 'Выйти',
    },
    ACCOUNT: {
      OVERVIEW: 'Обзор',
      SETTINGS: 'Настройки',
      PROFILE_DETAILS: 'Информация о профиле',
      FULL_NAME: 'Полное имя',
      FIRST_NAME: 'Имя',
      LAST_NAME: 'Фамилия',
      CONTACT_PHONE: 'Контактный телефон',
      COMMUNICATION: 'Коммуникация',
      ALLOW_CHANGES: 'Разрешить изменения',
      YES: 'Да',
      AVATAR: 'Аватар',
      CHANGE_AVATAR: 'Изменить аватар',
      CHOOSE_FILE: 'выбрать файл',
      SAVE_CHANGES: 'Сохранить изменения',
      EDIT_PROFILE: 'Редактировать профиль',
      PROFILE_DETAILS_UPDATED: 'Данные профиля обновлены!',
    },
    SIGN_IN_METHOD: {
      TITLE: 'Метод входа в систему',
      EMAIL_ADDRESS: 'Адрес электронной почты',
      CHANGE_EMAIL: 'Изменить электронную почту',
      PASSWORD: 'Пароль',
      CURRENT_PASSWORD: 'Текущий пароль',
      NEW_PASSWORD: 'Новый пароль',
      CONFIRM_CURRENT_PASSWORD: 'Подтвердить новый пароль',
      RESET_PASSWORD: 'Сброс пароля',
      ENTER_NEW_EMAIL_ADDRESS: 'Введите новый адрес электронной почты',
      UPDATE_EMAIL: 'Обновить электронную почту',
      UPDATE_PASSWORD: 'Обновить пароль',
      CANCEL: 'Отмена',
      PASSWORD_WAS_UPDATED: 'Пароль был успешно обновлен',
      INCORRECT_PASSWORD: 'Неверный пароль',
      PASSWORD_RULE: 'Пароль должен состоять не менее чем из 6 символов и содержать символы',
      VALIDATION: {
        CURRENT_PASS_REQUIRED: 'Требуется текущий пароль!',
        CURRENT_PASS_MIN: 'Текущий пароль должен содержать не менее 6 символов',
        CURRENT_PASS_MAX: 'Текущий пароль должен содержать не более 25 символов',
        NEW_PASS_REQUIRED: 'Требуется новый пароль!',
        NEW_PASS_MIN: 'Новый пароль должен содержать не менее 6 символов',
        NEW_PASS_MAX: 'Новый пароль должен содержать не более 25 символов',
        CONFIRM_PASS_REQUIRED: 'Требуется подтверждение пароля!',
        PASS_DO_NOT_MATCH: 'Пароли не совпадают!',
      },
    },
    FOOTER: {
      RIGHTS: 'Все права защищены',
    },
  },
};
